import { render, staticRenderFns } from "./OdpPaymentLogModal.vue?vue&type=template&id=13d19118&scoped=true"
import script from "./OdpPaymentLogModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OdpPaymentLogModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OdpPaymentLogModal.vue?vue&type=style&index=0&id=13d19118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d19118",
  null
  
)

export default component.exports